import script from "./systemConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./systemConfig.vue?vue&type=script&setup=true&lang=js"

import "./systemConfig.vue?vue&type=style&index=0&id=aef7b1e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aef7b1e6"]])

export default __exports__